const BannerPositionEnum = {
    TOP: 1,
    BOTTOM: 2
}
export default BannerPositionEnum



// WEBPACK FOOTER //
// ./src/enum/bannerPositionEnum.js